import '../sass/main.scss';

jQuery(function ($) {
  // Loading
  var $mv = $('#mvSlide');
  if ($mv.length) {
    var options = {
      // autoplay: true,
      autoplaySpeed: 5000,
      fade: true,
      arrows: false,
      dots: $mv.children().length >= 2,
      pauseOnFocus: false,
      pauseOnHover: false,
      lazyLoad: 'progressive'
    };
    $mv.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
      var is_logoimg = $mv.find('li:eq(' + nextSlide + ')').hasClass('main_logo');
      $('body').toggleClass('main_logo', is_logoimg);
    });
    $mv.slick(options);
    if ($('#splash').is(':visible')) {
      setTimeout(function () {
        $('body').removeClass('touch-disabled');
        $('#splash').addClass('fadeout');
        setTimeout(function () {
          $mv.slick('slickPlay');
        }, 2000);
      }, 6000);
    } else {
      $mv.slick('slickPlay');
    }
  }

  $('.section_title').wrapInner('<span></span>')

  $('.list-stack:not(.list-carousel) > *').each(function (i, e) {
    var tag = e.tagName.toLowerCase();
    var cname = e.className;
    $(this).parent().append($('<' + tag + ' class="' + cname + ' empty">'));
  });

  $('.list-carousel').slick({
    infinite: true,
    arrows: true,
    slidesToShow: 3,
    centerMode: true,
    centerPadding: 0,
    responsive: [{
      breakpoint: 767,
      settings: {
        slidesToShow: 1,
        centerPadding: '50px',
      }
    },{
      breakpoint: 481,
      settings: {
        slidesToShow: 1,
      }
    }]
  });

  lightbox.option({
    fadeDuration: 300
  });

  $('a[href^="#"]').click(function (e) {
    e.preventDefault();
    var href = $(this).attr('href');
    var $target = $(href === '#' || href === '' ? 'html' : href);
    var position = $target.offset().top;
    $('body, html').animate({scrollTop: position}, 200, 'swing');
  });

  $('.wow').one('inview', function (e, isInView) {
    if (isInView) {
      if ($(this).hasClass('random')) {
        var delay = Math.floor(Math.random() * 500);
        var self = this;
        setTimeout(function () {
          $(self).addClass('animated');
        }, delay)
      } else {
        $(this).addClass('animated');
      }
    }
  });

  // web予約
  if ($('#reservationButton').length) {
    var ticking = false;
    document.addEventListener('scroll', function () {
      if (!ticking) {
        requestAnimationFrame(function () {
          ticking = false;
          var threshold = window.innerHeight / 4;
          if (window.pageYOffset > threshold) {
            $('#reservationButton').addClass('visible');
          } else {
            $('#reservationButton').removeClass('visible');
          }
        });
        ticking = true;
      }
    }, { passive: true })
  }
  $('#reservationButton .close').on('click', function (e) {
    e.preventDefault();
    $('#reservationButton').addClass('hidden');
  })
});
